import PropTypes from 'prop-types';
import React from 'react';
import ListItemCreated from 'shared/_components/list/list-item-created';

const SeriesListItemDetails = ({ item }) => (
    <>
        <ListItemCreated key="created" value={item.created} />
        <div key="videoNumber">
            {/* TODO: Move numberOfVideos to item._totals and make it calculable as _totals from Project */}
            {`Number of Videos: ${item.numberOfVideos || 0}`}
        </div>
        <div key="playlistLevel">
            Playlist level: 1
        </div>
    </>
);
SeriesListItemDetails.propTypes = {
    item: PropTypes.shape({
        created: PropTypes.string,
        _totals: PropTypes.shape({
            fileCount: PropTypes.shape({}),
        }),
    }),
};

export default SeriesListItemDetails;
